import { CRRender } from '@/components/crRender'
import ImgPopup from '@/components/popups/imgPopup'
import { translate } from '@/utils/langUtils'
import { Icon } from '@iconify/react'
import { useRef, useState } from 'react';

const ProviderDocs = ({ documents }) => {

    const [viewingDocument, setViewingDocument] = useState("test");
    const imgRef = useRef(null);


    let mappedDocs = documents?.flatMap(doc => doc?.data);

    const getFileIcon = (name) => {
        let type = name.name?.split('.')[1]?.toLowerCase();
        if (type === 'pdf') return <Icon icon="fluent:document-pdf-16-filled" color="#dc2626" width="25" height="25" />;
        if (type === 'excel') return <Icon icon="mdi:file-excel-box" color="#059669" width="25" height="25" />;
        if (type === 'doc' || type === 'docx') return <Icon icon="mdi:file-word-box" color="#2563eb" width="25" height="25" />;
        if (["png", "jpg", "jpeg"].includes(type)) return <Icon icon="tabler:photo-filled" color="#f59e0b" width="25" height="25" />;
        return <Icon icon="akar-icons:file" color="#6b7280" width="25" height="25" />;
    }

    const handleViewDocument = (doc) => {
        if (doc?.name?.includes('.pdf')) return window.open(`${window.API_URL}${doc.name}`, "_blank");
        
        setViewingDocument(doc.name);
        imgRef.current.click();
    }

    return (
        <div className="submitted-documents">
            <h3 className="submitted-documents-title">{translate('submitted-documents')}</h3>
            <div className="documents-grid">
                {mappedDocs?.map((doc) => (
                    <div className="document-card pointer" key={doc?.id} onClick={() => handleViewDocument(doc)}>
                        {getFileIcon(doc)}
                        <span className="document-name">{doc.name?.split('/')?.[1]?.split(".")?.[0]}</span>

                    </div>
                ))}
            </div>
            <ImgPopup isHideText link={viewingDocument} refImg={imgRef} />
        </div>
    )
}

export default ProviderDocs